import API from '../';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class InstitutionsAPI extends API {
	getCustomInfo() {
		return this.requestWrapper(this.request({ url: `${this.scheme}` }));
	}

	institucionCRUD(tipoOperacion, tipo, nombreI, idInstituto, prefijo) {
		const prefix = prefijo ? `&prefijo=${prefijo}` : '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=${tipoOperacion}&tipo=${tipo}&nombreInstitucion=${nombreI}&idInstituto=${idInstituto}${prefix}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	changeinstitucionStatus(status, idInstituto, prefijo) {
		const prefix = prefijo ? `&prefijo=${prefijo}` : '';
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=4&estatus=${status}&idInstituto=${idInstituto}${prefix}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	institutionCreate(tipo, nombreI) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=1&tipo=${tipo}&nombreInstitucion=${nombreI}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	institutionDelete(idInstituto) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=5&idInstituto=${idInstituto}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	institutionId(idInstituto, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=2&idInstituto=${idInstituto}${paginationUrl}`,
				method:  HTTP_METHODS.post_M,
			})
		);
	}

	institutionPrefijo(prefijo, tipo, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=2&prefijo=${prefijo}&tipo=${tipo}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	institutionStatus(status, tipo, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=2&estatus=${status}&tipo=${tipo}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getAllinstitutions(tipo, pagination, currentPage) {
		const paginationUrl = pagination
			? `&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`
			: '';

		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/institucionCRUD?tipoOperacion=2&tipo=${tipo}${paginationUrl}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const institutionsAPI = new InstitutionsAPI('/instituciones');
